// @flow

import React from 'react';
import styled from 'styled-components';

import Header from '../components/Header';

import typeof TTheme from '../theme';
import type { LoadingProps } from 'react-loadable';

type TP = {
  prerender?: boolean,
  theme: TTheme,
};

const Title = styled.div`
  background: ${({ theme, prerender }: TP) =>
    prerender ? theme.colors.silver : 'transparent'};
  height: 26px;
  width: 220px;
`;

const Subtitle = styled.div`
  background: ${({ theme, prerender }: TP) =>
    prerender ? theme.colors.silver : 'transparent'};
  height: 20px;
  width: 160px;
`;

type Props = {
  children?: any,
  prerender?: boolean,
};

const PreloadScreen = ({ children, prerender }: Props) => (
  <div>
    <Header
      header={<Title prerender={prerender} />}
      subheader={<Subtitle prerender={prerender} />}
    />
    {children}
  </div>
);

const LoadingScreen = (props: LoadingProps) => {
  if (props.isLoading) {
    // While our other component is loading...
    if (props.timedOut) {
      // In case we've timed out loading our other component.
      return <div>{'Loader timed out!'}</div>;
    } else if (props.pastDelay) {
      // Display a loading screen after a set delay.
      return <PreloadScreen prerender {...props} />;
    } else {
      // Don't flash "Loading..." when we don't need to.
      return <PreloadScreen {...props} />;
    }
  } else if (props.error) {
    // If we aren't loading, maybe
    return <div>{'Error! Component failed to load.'}</div>;
  } else {
    // This case shouldn't happen... but we'll return null anyways.
    return null;
  }
};

export default LoadingScreen;



// WEBPACK FOOTER //
// ./src/App/PreloadScreen.js